module.exports = "<div class=\"modal-detail-container hide-modal-detail\">\n    <div class=\"modal-detail\" [style.width]=\"isAlert ? '400px' : ''\">\n        <ng-content></ng-content>\n    </div>\n    <div class=\"modal-detail-mask\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal-detail/modal-detail.component.html
// module id = ./src/app/shared/components/modal-detail/modal-detail.component.html
// module chunks = main